module.exports = {
      id: "eye-usage",
      viewBox: "0 0 32.7 21.5",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#eye-usage",
      toString: function () {
        return this.url;
      }
    }